import { useState } from 'react';
import { materias } from '../data/materias';
const Materias = ({setCalculado, setAudeudadas,setElectivas}) => {
    const checked = true;
    const initialForm = materias.map(
        ({ materia, nivel, horas, electiva }, id) => ({ id, nivel, materia, horas, electiva, checked })
    );
    const [form, setForm] = useState(initialForm);
    //let horasDeLaCarrera = 0;
    //materias.forEach(({ horas }) => horasDeLaCarrera += parseInt(horas));
    
    const handleChecked = (event) => {
        let { id, checked } = event.target;
        //console.log(id)
        const auxForm = [...form];
        auxForm[id].checked=checked;
        setForm(auxForm);
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const materiasCursadas = form.filter(({ checked }) => checked);
        const materiasAdeudadas = form.filter(({ checked }) => !checked);
        let horasCursadas = 0;
        let electivasCursadas=0;
        materiasCursadas.forEach(
            (m) =>{ 
                horasCursadas +=m.horas;
                if(m.electiva){
                    electivasCursadas+=m.horas;
                }
            }
        );
        setCalculado(horasCursadas);
        setAudeudadas(materiasAdeudadas);
        setElectivas(electivasCursadas);
        

    }
    return (
        <form
            className='card-body row'
            onSubmit={handleSubmit}
        >
            <table className="table table-info table-sm  text-center p-3 table-bordered border-primary">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nivel</th>
                        <th scope="col">Materias</th>
                        <th scope="col">Horas</th>
                        <th scope="col">Cursada</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        materias.map(({ nivel, materia, horas }, i) =>
                            <tr className={nivel % 2 === 0 ? 'table-secondary' : 'table-dark'} key={i + 1} >
                                <th scope="row">{i + 1}</th>
                                <td>{nivel}</td>
                                <td>{materia}</td>
                                <td>{horas}</td>
                                <td>
                                    <input
                                        onChange={handleChecked}
                                        type="checkbox"
                                        defaultChecked
                                        value={horas}
                                        className={materia}
                                        id={i}
                                    />
                                </td>
                            </tr>
                        )
                    }

                </tbody>
            </table>
            <div className="col-12">
                <button
                    type='submit'
                    className='btn btn-success float-end'
                >
                    Calcular
                </button>
            </div>
        </form>
    )
}

export default Materias;